import React, { useState } from 'react';
import TimeZoneConverter from '../shared/timezone';
import { TextHighlighter } from '../shared/textBold';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';

export const AllData = ({ data, settabInd }) => {
	console.log(data, "data");
	const [searchParams, setSearchParams] = useSearchParams();

	function handleNavigateInv(obj) {
		const params = createSearchParams({ 
		client_id: obj?.client_id,
		client_name: obj?.client,
		client_list_page_no: 1,
		client_list_sort_key: '',
		client_list_sort_order: '',

		vendor_id: obj?.vendor_id,
		vendor_name: obj?.vendor,
		vendor_list_page_no : 1,
		vendor_list_sort_key: '',
		vendor_list_sort_order: '',
		category_name: obj?.category_name,
		category_id: obj?.category_id,

		invoice_id: obj._id,
		invoice_name: obj.fname,
		invoice_list_page_no : 1,
		invoice_list_sort_key: '',
		invoice_list_sort_order: '',
	}).toString();

	window.open(`/my-annotations?${params}`, '_blank'); // 
				
	}


	function handleNavigateCont(obj) {
			const params = createSearchParams({ 
			client_id: obj?.client_id,
			client_name: obj?.client,
			client_list_page_no: 1,
			client_list_sort_key: '',
			client_list_sort_order: '',

			vendor_id: obj?.vendor_id,
			vendor_name: obj?.vendor,
			vendor_list_page_no : 1,
			vendor_list_sort_key: '',
			vendor_list_sort_order: '',
			category_name: obj?.category_name,
			category_id: obj?.category_id,

			contract_id: obj._id,
			contract_name: obj.fname,
			contract_list_page_no : 1,
			contract_list_sort_key: '',
			contract_list_sort_order: '',
		}).toString();

		window.open(`/my-contract-details?${params}`, '_blank'); // 
					
		}



	return (
		<>
			{['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No text searched</p>
					</div>}

			<div className="border-2 pt-5 px-4 pb-0 rounded-lg mt-8 relative min-h-32">
				<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
					Invoices
				</label>
				<div style={{overflow: "auto"}} className="listDHeight autoHe8 overflow-auto">
					{/* Table body head */}
					{data?.invoice?.length > 0 && <div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none w-[140px] pr-4">
								<label
									className={`font-black block w-[140px] relative cursor-pointer`}
								>
									Name of Document
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Client
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Category
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Project Type
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Vendor
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded By
								</label>
							</div>
							<div className="flex-none pl-8 pr-4  text-center w-[150px]">
								<label className={`font-black block relative cursor-pointer`}>
									Published Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Updated Date
								</label>
							</div>
							
						</div>
						<div className="opacity-0 flex-none px-4 text-center w-[106px]">
							<label className={`font-black block relative cursor-pointer`}>
									&nbsp;
								</label>
								
							</div>
					</div> }
					{/* Table body Row */}
					{data?.invoice?.length ==0 && !['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No data found</p>
					</div>}
		
					{data?.invoice?.slice(0, 5).map((obj, index) => {
						return (
							<div className="flex gap-2 mb-2 tblLoop">
								<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
									
									<div className="w-[140px] relative flex border-r pr-4 items-center">
										<span
											title={obj?.fname}
											className="absolute w-full block truncate"
										>
											{obj?.fname ? <TextHighlighter text={obj.fname} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.client}
											className="absolute w-full block truncate"
										>
											{obj?.client ? <TextHighlighter text={obj.client} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.category_name}
											className="absolute w-full block truncate"
										>
											{obj?.category_name ? <TextHighlighter text={obj.category_name} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.project_type}
											className="absolute w-full block truncate"
										>
											{obj?.project_type ? <TextHighlighter text={obj.project_type} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.vendor}
											className="absolute w-full block truncate"
										>
											{obj?.vendor ? <TextHighlighter text={obj.vendor} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.uploaded_by}
											className="absolute w-full block truncate"
										>
											{obj?.uploaded_by || <span className="text-gray-500">-</span>}
										</span>
									</div>
									<div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter  utcTimestamp={obj.uploaded_at} />
									</div>
									<div className="flex-none border-r px-4 text-center w-[140px]">
										<TimeZoneConverter  utcTimestamp={obj.uploaded_at} />
									</div>
									<div className="flex-none px-4 text-center w-[140px]">
										<TimeZoneConverter  utcTimestamp={obj.updated_at} />
									</div>
									

								</div>
								<div className="flex-none flex w-[106px] pr-2">
										<button
											disabled={obj?.percentage_complete<100}
											onClick={() => handleNavigateInv(obj)}
											type="button"
											title={obj?.percentage_complete<100 ? 'Processing Invoice' : ''}
											className="vLBG block px-0 py-3 w-full text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
										>
											View
										</button>
									</div>
							</div>
						)
					})}
					
				</div>
				{data?.invoice?.length >0 && <button onClick={()=> settabInd(1)} className="absolute -bottom-4 left-[50%] ml-[-110px] font-bold text-primary text-sm px-3 py-1 bg-white border border-primary rounded-lg">
					View more +
				</button>}
			</div>

			{/* Contracts */}
			<div className="border-2 pt-5 px-4 pb-0 rounded-lg mt-8 relative min-h-32">
				<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
					Contracts
				</label>
				<div style={{overflow: "auto"}} className="listDHeight autoHe8 overflow-auto">
					{/* Table body head */}
					{data?.contract?.length > 0 && <div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none pr-4">
								<label
									className={`font-black block w-[140px] relative cursor-pointer`}
								>
									Name of Document
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Client
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Category
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Project Type
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Vendor
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[155px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded By
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Start Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									End Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<label className={`font-black block relative cursor-pointer`}>
									Uploaded Date
								</label>
							</div>
							
						</div>
						<div className="opacity-0 flex-none px-4 text-center w-[106px]">
							<label className={`font-black block relative cursor-pointer`}>
									&nbsp;
								</label>
								
							</div>
					</div>}
					{/* Table body Row */}
					{data?.contract?.length ==0 && !['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No data found</p>
					</div>}

					{data?.contract?.slice(0, 5).map((obj, index) => {
						return (
							<div className="flex gap-2 mb-2 tblLoop">
						<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
							<div className="flex-none w-[140px] relative flex border-r pr-4 items-center">
								<span
									title={obj?.fname}
									className="absolute w-full block truncate"
								>
									{obj?.fname ? <TextHighlighter text={obj.fname} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
								<span
									title={obj?.client}
									className="absolute w-full block truncate"
								>
									{obj?.client ? <TextHighlighter text={obj.client} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
								<span
									title={obj?.category_name}
									className="absolute w-full block truncate"
								>
									{obj?.category_name ? <TextHighlighter text={obj.category_name} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
								<span
									title={obj?.project_type}
									className="absolute w-full block truncate"
								>
									{obj?.project_type ? <TextHighlighter text={obj.project_type} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
								<span
									title={obj?.vendor}
									className="absolute w-full block truncate"
								>
									{obj?.vendor ? <TextHighlighter text={obj.vendor} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
								<span
									title={obj?.uploaded_by}
									className="absolute w-full block truncate"
								>
									{obj?.uploaded_by || <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none border-r px-4 text-center w-[140px]">
								<TimeZoneConverter  utcTimestamp={obj?.start_date} />
							</div>
							<div className="flex-none border-r px-4 text-center w-[140px]">
								<TimeZoneConverter  utcTimestamp={obj?.end_date} />
							</div>
							<div className="flex-none px-4 text-center w-[140px]">
								<TimeZoneConverter  utcTimestamp={obj?.uploaded_at} />
							</div>
						</div>
						<div className="flex-none flex w-[106px] pr-2">
								<button
									disabled={obj?.percentage_complete<100}
									onClick={() => handleNavigateCont(obj)}
									type="button"
									title={obj?.percentage_complete<100 ? 'Processing Contract' : ''}
									className="vLBG block px-0 py-3 w-full text-center text-primary text-sm rounded-md font-black mx-1 disabled:bg-gray-200 disabled:text-gray-500"
								>
									View
								</button>
							</div>
					</div>
						)})}
		
				</div>
				{data?.contract?.length >0 && <button onClick={()=> settabInd(2)} className="absolute -bottom-4 left-[50%] ml-[-110px] font-bold text-primary text-sm px-3 py-1 bg-white border border-primary rounded-lg">
					View more +
				</button>}
			</div>

			{/* Clients */}
			<div className="border-2 pt-5 px-4 pb-0 rounded-lg mt-8 relative min-h-32">
				<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
					Clients
				</label>
				<div style={{overflow: "auto"}} className="listDHeight autoHe8 overflow-auto">
					{/* Table body head */}
					{data?.client?.length > 0 && <div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none w-[140px]">
								<label
									className={`font-black block relative cursor-pointer`}
								>
									Name
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Total Vendor
								</label>
							</div>

							<div className="flex-none px-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Created Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Updated Date
								</label>
							</div>
						</div>
					</div>} 
					{/* Table body Row */}
					{data?.client?.length ==0 && !['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No data found</p>
					</div>}
					{data?.client?.slice(0, 5).map((obj, index) => {
						return (
							<div className="flex gap-2 mb-2 tblLoop">
						<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
							<div className="flex-none w-[140px] relative flex border-r pr-4 items-center">
								<span
									title={obj?.name}
									className="absolute w-full block truncate"
								>
									{obj?.name ? <TextHighlighter text={obj.name} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center border-r pr-4 text-center w-[240px] relative">
								<span
									title={obj?.total_vendors}
									className="absolute w-full block truncate"
								>
									{obj?.total_vendors || <span className="text-gray-500">-</span>}
								</span>
							</div>
							
							<div className="flex-none border-r px-4 text-center w-[240px]">
								<TimeZoneConverter  utcTimestamp={obj?.created_at} />
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<TimeZoneConverter  utcTimestamp={obj?.updated_at} />
							</div>
						</div>
					</div>

						)})}

				</div>
				{data?.client?.length >0 && <button onClick={()=> settabInd(3)} className="absolute -bottom-4 left-[50%] ml-[-110px] font-bold text-primary text-sm px-3 py-1 bg-white border border-primary rounded-lg">
					View more +
				</button>}
			</div>

			{/* Vendors */}
			<div className="border-2 pt-5 px-4 pb-0 rounded-lg mt-8 relative min-h-32">
				<label className="absolute -top-6 left-4 font-black text-primary text-lg px-1 py-2 bg-white">
					Vendors
				</label>
				<div style={{overflow: "auto"}} className="listDHeight autoHe8 overflow-auto">
					{/* Table body head */}
					{data?.vendor?.length > 0 && <div className="flex gap-2 mb-2">
						<div className="grow px-5 py-1 text-xs flex items-center justify-between">
							<div className="flex-none w-[140px]">
								<label
									className={`font-black block relative cursor-pointer`}
								>
									Name
								</label>
							</div>
							<div className="flex-none pl-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Alias
								</label>
							</div>
						
							<div className="flex-none px-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Created Date
								</label>
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<label className={`font-black block relative cursor-pointer`}>
									Updated Date
								</label>
							</div>
						</div>
					</div>}
					{data?.vendor?.length ==0 && !['', null].includes(searchParams.get('keyword')) && <div class="flex items-center justify-center h-12">
						<p class="text-gray-500 text-lg font-medium">No data found</p>
					</div>}

					{data?.vendor?.slice(0, 5).map((obj, index) => {
						return (
							<div className="flex gap-2 mb-2 tblLoop">
						<div className="grow border rounded-md px-5 py-3 text-sm flex items-center justify-between">
							<div className="flex-none w-[140px] relative flex border-r pr-4 items-center">
								<span
									title={obj?.name}
									className="absolute w-full block truncate"
								>
									{obj?.name ? <TextHighlighter text={obj.name} searchString={searchParams.get('keyword')} /> : <span className="text-gray-500">-</span>}
								</span>
							</div>
							<div className="flex-none flex items-center border-r pr-4 text-center w-[240px] relative">
								<span
									title={obj?.alias}
									className="absolute w-full block truncate"
								>
									{obj?.alias || <span className="text-gray-500">-</span>}
								</span>
							</div>
							
							<div className="flex-none border-r px-4 text-center w-[240px]">
								<TimeZoneConverter  utcTimestamp={obj?.created_at} />
							</div>
							<div className="flex-none px-4 text-center w-[240px]">
								<TimeZoneConverter  utcTimestamp={obj?.updated_at} />
							</div>
						</div>
					</div>

						)})}

				</div>
				{data?.vendor?.length >0 && <button onClick={()=> settabInd(4)} className="absolute -bottom-4 left-[50%] ml-[-110px] font-bold text-primary text-sm px-3 py-1 bg-white border border-primary rounded-lg">
					View more +
				</button>}
			</div>
		</>
	);
};
